import * as scene from './scene.js';
import { createPanner } from './audio/panner.js';
import * as audio from './audio.js';
import * as compass from './ui/compass.js';
import * as player from './player.js';

export {
    init,
    drop,
    checkComplete,
    activateTriangle,
}

const queuedTriangles = [];

function init() {

}

function isCollected(name) { // TODO: think to name this differently and separate collectible and center triangles
    return scene.POIs.find(p => p.name === name).style === 'active';
}

function drop(name, position, options) {
    /*
        Options:
        - color
        - gain (dB)
        - collisionRadius (m)
        - offset {x, y} (m)
        - delay (s)
        - despawn (s)
    */
    const pos = {
        x: position.x + (options.offset?.x || 0),
        y: position.y + (options.offset?.y || 0),
        z: 0
    }

    // Prevent dropping a collectible if its center sibling is already activated
    if (isCollected(name)) return;

    // Prevent dropping a collectible triangle again if its waiting for a timeout
    if (queuedTriangles.includes(`${name}-collectible`)) return;

    // Prevent dropping a collectible if it already exists
    if (scene.POIs.find(p => p.name === `${name}-collectible`)) return;

    const centerTriangle = scene.POIs.find(p => p.name === name);

    // Drop a triangle at the given position
    const triangle = {
        name: `${name}-collectible`,
        position: pos,
        color: options.color || centerTriangle.color || 'hsl(0, 100%, 50%)',
        type: 'triangle',
        radius: 7.5,
        hideOnMap: true,
        collision: {
            radius: options.collisionRadius || 1,
        },
        onEnter() {
            // Remove the triangle from the scene with splice
            const index = scene.POIs.indexOf(this);
            scene.POIs.splice(index, 1);

            audio.buffers.play('ding', {
                gain: options.gain || 0,
            });

            // Prevent the player from moving
            player.config.controllable = false;

            // Zoom to the origin
            compass.zoomToOrigin();

            setTimeout(() => { // TODO: Use a promise from compass.zoomToOrigin
                activateTriangle(name, options.gain || 0);
            }, 3000);
        },
    };

    const panner = createPanner();
    panner.positionPanner(pos.x, pos.z, pos.y); // TODO: just pass pos !

    // Drop triangle after a few seconds
    setTimeout(() => {
        audio.buffers.play('ding-pop', {
            destination: panner,
            gain: options.gain || 0,
        });

        scene.POIs.push(triangle);

        queuedTriangles.splice(queuedTriangles.indexOf(triangle.name), 1);
    }, (options.delay * 1000) || 0);

    if (options.despawn) {
        setTimeout(() => {
            const index = scene.POIs.indexOf(triangle);
            if (index) scene.POIs.splice(index, 1);
        }, options.despawn * 1000);
    }

    queuedTriangles.push(triangle.name);
}

function checkComplete() {
    // Check if all collectible triangles have been picked
    const activeStonehengeTriangles = scene.POIs.filter(p => {
        return p.name.includes('stonehenge-triangle') && p.style === 'active'
    });

    return (activeStonehengeTriangles.length === 8)
}

function activateTriangle(name, gain = 0, zoomBack = true) {
    audio.buffers.play('ding2', {
        gain: gain,
    });
    const triangle = scene.POIs.find(p => p.name === name);
    triangle.style = 'active';

    const complete = checkComplete();

    setTimeout(() => {
        if (!complete) {
            if (zoomBack) zoomBackToPlayer();
        } else {
            animateStonehengeComplete();
        }
    }, 2000);
}

function animateStonehengeComplete() {
    audio.buffers.play('ding-final');
    const center = scene.POIs.find(p => p.name === 'stonehenge-center');
    center.style = 'complete';

    setTimeout(() => {   
        zoomBackToPlayer();
    }, 2000);
}

function zoomBackToPlayer() {
    compass.zoomToPlayer();

    setTimeout(() => { // TODO: Use a promise from compass.zoomToOrigin
        player.config.controllable = true;
    }, 2000);
}